import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getGeometryFilter, getProjectDataSourceFilters } from "../../../ducks/project/selectors";
import { setProjectDataSourceFilters } from "../../../ducks/project/project";
import { formatDateFilter } from "../utils/formatDateFilter";
import { getDateFilterConditions } from "../../../ducks/dateFilter/selectors";
import { formatGeometryFilter } from "../utils/formatGeometryFilter";
import { useGeometrySelectionConditions } from "../../../hooks/geometrySelection/useGeometrySelectionConditions";
import { SelectedFilters } from "../types";

export const useProjectDataSourceFilters = () => {
  const dispatch = useDispatch();
  const dataSourceFilters = useSelector(getProjectDataSourceFilters);
  const dateFilterConditions = useSelector(getDateFilterConditions);
  const geometryFilter = useSelector(getGeometryFilter);
  const geometrySelectionConditions = useGeometrySelectionConditions();

  const changeFilters = useCallback(
    (newFilters: SelectedFilters) => {
      dispatch(setProjectDataSourceFilters({ ...dataSourceFilters, ...newFilters }));
    },
    [dispatch, dataSourceFilters],
  );

  const filters = useMemo(
    () => ({
      ...dataSourceFilters,
      ...formatDateFilter(dateFilterConditions),
      ...formatGeometryFilter(geometrySelectionConditions, geometryFilter),
    }),
    [dataSourceFilters, dateFilterConditions, geometryFilter, geometrySelectionConditions],
  );

  return [filters, changeFilters] as const;
};
